import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private baseurl = environment.apiUrl;

  constructor(private httpService: HttpClient) {}
  Params = new HttpParams();

  // Http get Requests
  getData<T>(api: any, params?: HttpParams): Observable<T> {
    return this.httpService.get<T>(`${this.baseurl}${api}`, { params });
  }

  // Http post Requests
  postData<T>(api: any, body: any): Observable<T> {
    return this.httpService.post<T>(`${this.baseurl}${api}`, body);
  }

  // Http put Requests
  putData<T>(api: any, body: any): Observable<T> {
    return this.httpService.put<T>(`${this.baseurl}${api}`, body);
  }

  // Http delete Requests
  deleteData<T>(api: any): Observable<T> {
    return this.httpService.delete<T>(`${this.baseurl}${api}`);
  }

  patchData<T>(api: any, body: any): Observable<T> {
    return this.httpService.patch<T>(`${this.baseurl}${api}`, body);
  }

  getBlobData(api: any, params?: HttpParams): Observable<Blob> {
    return this.httpService.get(`${this.baseurl}${api}`, {
      params,
      responseType: 'blob' as 'json'
    }) as Observable<Blob>;
  }
}
